import {translate as t} from '../i18n';

const translateMessage = error => {
  const errorKey = `errors.${error.code}`;
  const message = t(errorKey);
  if (message !== errorKey) {
    error.message = message;
  }
  return error;
};

const translateOldError = response => {
  return {
    status: response.status,
    logref: response.data.logref,
    details: response.data.data
      .filter(e => e.propertyName !== 'errorCode')
      .map(e => {
        return {
          path: e.propertyName,
          message: e.propertyValue
        };
      })
  };
};

const translateOldConflict = response => {
  return {
    status: response.status,
    details: [
      {
        code: '300102',
        data: {
          conflictingTemplateUid: response.data.id,
          name: response.data.name
        }
      }
    ]
  };
};

export default response => {
  if (response.data !== undefined) {
    if (response.data.errors === null && Array.isArray(response.data.data)) {
      return translateOldError(response);
    } else if (response.data.errors !== undefined) {
      return {
        status: response.status,
        details: response.data.errors.map(e => translateMessage(e)),
        logref: response.data.logref
      };
    } else if (response.status === 409) {
      return translateOldConflict(response);
    }
  }

  return {
    status: response.status,
    details: []
  };
};
